"use strict";
var React = require("react");
var { Modal, Button, ButtonToolbar, closeButton } = require("react-bootstrap");
var EditProfileForm = require("./EditProfileForm");

var EditProfileModal = React.createClass({
    onSubmit(event) {
        this.props.onHide();
        event.preventDefault();
        this.refs.editProfileForm.onSubmit();
    },
    render: function() {
        return (
            <Modal id="editProfileModal" {...this.props} bsStyle='primary' animation={false}>
                <Modal.Header closeButton>
                     <Modal.Title>Breyta notanda</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <EditProfileForm ref="editProfileForm" user={this.props.user}/>
                </Modal.Body>
                <Modal.Footer>
                    <ButtonToolbar>
                        <Button onClick={this.onSubmit} type='submit'>Vista</Button>
                        <Button onClick={this.props.onHide}>Hætta við</Button>
                    </ButtonToolbar>
                </Modal.Footer>
            </Modal>
        );
    }
});

module.exports = EditProfileModal;



// WEBPACK FOOTER //
// ./app/scripts/ui/UserProfile/EditProfileModal.js